import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox, Label } from '@Sage/hoi-poi-ui';

import './Checkbox.scss';

const propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    fieldId: PropTypes.string,
    hidden: PropTypes.bool,
    label: PropTypes.any,
    mandatory: PropTypes.bool,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    shouldRenderField: PropTypes.func,
    value: PropTypes.bool,
};

const CheckboxField = ({
    className,
    description,
    fieldId,
    hidden,
    label,
    mandatory,
    onChange,
    readOnly,
    shouldRenderField,
    value = false,
}) => {
    const handleChange = useCallback(() => {
        if (readOnly) return;
        onChange?.(!value);
    }, [onChange, readOnly, value]);

    if (hidden) return null;
    if (shouldRenderField && !shouldRenderField(fieldId)) return null;

    return (
        <div className={classnames('fm-field-checkbox-v2', className)}>
            <Checkbox checked={!!value} isDisabled={readOnly} onChange={handleChange} />
            {label != null && label !== '' && (
                <Label
                    className="fm-field-checkbox-v2__label"
                    hint={description}
                    isRequired={mandatory}
                >
                    {label}
                </Label>
            )}
        </div>
    );
};

CheckboxField.displayName = 'CheckboxField';
CheckboxField.propTypes = propTypes;

export default memo(CheckboxField);
